import { useCallback, useEffect } from 'react';

type KeyOptions = {
  key: string;
  ctrlKey?: boolean;
};

const useKeyPress = (options: KeyOptions[], handler: () => void) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      options.forEach((option) => {
        if (
          event.key === option.key &&
          event.ctrlKey === Boolean(option.ctrlKey)
        ) {
          handler();
        }
      });
    },
    [options, handler],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};

export default useKeyPress;
